export const enum SortingOrder {
  Ascending = "0",
  Descending = "1",
}
